import { render, staticRenderFns } from "./messageTemplateForm.vue?vue&type=template&id=f6eae132&scoped=true"
import script from "./messageTemplateForm.vue?vue&type=script&lang=js"
export * from "./messageTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./messageTemplateForm.vue?vue&type=style&index=0&id=f6eae132&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6eae132",
  null
  
)

export default component.exports